import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=531f8998&scoped=true&"
import script from "./AddOns.vue?vue&type=script&lang=js&"
export * from "./AddOns.vue?vue&type=script&lang=js&"
import style0 from "./AddOns.vue?vue&type=style&index=0&id=531f8998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f8998",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VSelect,VSpacer})
